import { render, staticRenderFns } from "./ServiceOrderDetail.vue?vue&type=template&id=7f0ac352&scoped=true&"
import script from "./ServiceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderDetail.vue?vue&type=style&index=0&id=7f0ac352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ac352",
  null
  
)

export default component.exports